// extracted by mini-css-extract-plugin
export default {"service_card":"join_service_card__avhJ6","joinCard":"join_joinCard__iuhoN"};